import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import { KnBrCartContextService } from '../../../../base/core/facade/kn-br-cart-context.service';
import { KnBrQuoteContextAdapter } from '../../connectors/kn-br-quote-context.adapter';
import {
  KnBrQuoteAddUpdateContext,
  KnBrQuoteContextActions,
  KnBrQuoteContextActionTypes,
  KnBrQuoteLoadSuccessContext,
  KnBrQuoteRemoveContext,
  KnBrQuoteResetContext,
} from '../actions/kn-br-quote-context.actions';

@Injectable()
export class KnBrQuoteContextEffects {
  //@Effect()
  loadQuoteContext$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KnBrQuoteContextActionTypes.KnBrQuoteContextLoadAction),
      map(() => {
        const context = this.knBrQuoteContextAdapter.get();
        return new KnBrQuoteLoadSuccessContext(context);
      })
    )
  );
  //@Effect({ dispatch: false })
  addUpdateQuoteContext$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(KnBrQuoteContextActionTypes.KnBrQuoteContextAddUpdateAction),
        map((action: KnBrQuoteAddUpdateContext) => action.payload),
        map((quoteCode: string) => {
          this.knBrCartContextService.delete();
          this.knBrQuoteContextAdapter.set(quoteCode);
        })
      ),
    { dispatch: false }
  );
  //@Effect({ dispatch: false })
  removeQuoteContext$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(KnBrQuoteContextActionTypes.KnBrQuoteContextRemoveAction),
        map((action: KnBrQuoteRemoveContext) => action.payload),
        map(() => {
          this.knBrQuoteContextAdapter.remove();
        })
      ),
    { dispatch: false }
  );
  //@Effect({ dispatch: false })
  resetQuoteContext$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(KnBrQuoteContextActionTypes.KnBrQuoteContextResetAction),
        map((action: KnBrQuoteResetContext) => action.payload),
        map(() => {
          this.knBrQuoteContextAdapter.remove();
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions<KnBrQuoteContextActions>,
    private knBrQuoteContextAdapter: KnBrQuoteContextAdapter,
    private knBrCartContextService: KnBrCartContextService
  ) {}
}
